<div class="main-container">

  <div class="header main-header" data-cy="perio-probing-summary-header">Perio Screening Score</div>
  <i class="material-icons exit-button" (click)="close()" data-cy="perio-probing-summary-close-button">close</i>

  <div class="flex-container main-scoring-container">

    <div class="flex-item scoring-container">
      <div class="sub-header" data-cy="perio-probing-summary-average-depth-header">Average Probing Depth</div>
      <div class="flex-container section-container">
        @for (segment of segments; track segment) {
          <div class="flex-item scoring-item">
            <div class="segment-header" data-cy="perio-probing-summary-average-depth-segment-header">S{{segment}}</div>
            <div class="segment-value" data-cy="perio-probing-summary-average-depth-segment-value">{{ probingSegmentData[getSegmentStatKey(segment, 'average')] }}</div>
          </div>
        }
      </div>
    </div>

    <div class="flex-item scoring-container">
      <div class="sub-header" data-cy="perio-probing-summary-lowest-depth-header">Lowest Probing Depth</div>
      <div class="flex-container section-container">
        @for (segment of segments; track segment) {
          <div class="flex-item scoring-item">
            <div class="segment-header" data-cy="perio-probing-summary-lowest-depth-segment-header">S{{segment}}</div>
            <div class="segment-value" data-cy="perio-probing-summary-lowest-depth-segment-value">{{ probingSegmentData[getSegmentStatKey(segment, 'lowest')] }}</div>
          </div>
        }
      </div>
    </div>



  </div>


</div>
